// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___U_Y5F","text":"text___2MQ6E","sliderWrapper":"sliderWrapper___3KrjS","size":"size___1oLXm","slider":"slider___2YeD2"};